import { render } from "./DettaglioRaccoltaIstanza.vue?vue&type=template&id=71145e5f&scoped=true"
import script from "./DettaglioRaccoltaIstanza.vue?vue&type=script&lang=js"
export * from "./DettaglioRaccoltaIstanza.vue?vue&type=script&lang=js"

import "./DettaglioRaccoltaIstanza.vue?vue&type=style&index=0&id=71145e5f&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71145e5f"]])

export default __exports__